<template>
  <Can action="view" subject="ad-manager.order">
    <dialog-line-edit
      :order="order"
      :line-item="selectedLineItem"
      :is-on="true"
      :is-loading="isLoadingLineItem"
      :is-loading-details="isLoadingDetails"
      :is-updating="isUpdatingLineItem"
      :on-cancel="onCancel"
      :on-confirm="updateLineItem"
      :on-change-status="updateLineStatus"
    />
  </Can>

  <Can action="view-business-contact" subject="ad-manager.order">
    <dialog-line-edit-k-b
      :order="order"
      :line-item="selectedLineItem"
      :is-on="true"
      :is-loading="isLoadingLineItem"
      :is-loading-details="isLoadingDetails"
      :is-updating="isUpdatingLineItem"
      :on-cancel="onCancel"
      :on-confirm="updateLineItem"
      :on-change-status="updateLineStatus"
    />
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        selectedLineItem: {},
        isLoadingLineItem: false,
        isLoadingDetails: false,
        isUpdatingLineItem: false,
      };
    },
    computed: {
      order() {
        return this.$store.getters['promotions/activeItem'] || {};
      },
      orderId() {
        return Number(this.$route.params.id);
      },
      lineId() {
        return Number(this.$route.params.lineId);
      },
      isBC() {
        return this.$ability.can('view-business-contact', 'ad-manager.order');
      },
    },
    created() {
      this.getLineItemById();
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'promotion-details', params: { id: this.orderId } });
      },
      getLineItemById() {
        const raw = this.order?.lines?.find(l => l.id === this.lineId);
        if (raw?.targeting) {
          const cached = {
            frequency_caps: [],
            itm_campaign: '',
            itm_medium: '',
            thread: null,
            cost_type: null,
            ...raw,
            targeting: {
              geo: [],
              devices: [],
              ...raw.targeting,
              custom: {
                groups: [],
                users: [],
                ...raw.targeting?.custom,
              },
            },
          };
          this.$nextTick(() => {
            this.selectedLineItem = cached;
          });
        }

        const query = {
          country: this.order?.country?.code,
          orderId: this.orderId,
          lineId: this.lineId,
        };

        if (raw?.targeting) {
          this.isLoadingDetails = true;
        } else {
          this.isLoadingLineItem = true;
        }

        return this.$store.dispatch('promotions/getLineItemById', query)
          .then((res) => {
            this.selectedLineItem = res.activeLineItem;
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isLoadingLineItem = false;
            this.isLoadingDetails = false;
          });
      },
      updateLineItem(lineItem) {
        this.isUpdatingLineItem = true;

        return this.$store.dispatch('promotions/updateLineItem', lineItem)
          .then((res) => {
            if (res.activeLineItem) {
              this.$router.push({ name: 'promotion-details', params: { id: this.orderId } });
            }
            return res;
          })
          .finally(() => {
            this.isUpdatingLineItem = false;
          });
      },
      updateLineStatus(query) {
        const { orderId, lineItemId, statusId } = query;

        const nextQuery = {
          country: this.order?.country?.code,
          orderId,
          lineItemId,
          statusId,
          isBC: this.isBC,
        };

        this.isUpdatingLineItem = true;

        return this.$store.dispatch('promotions/updateLineStatus', nextQuery)
          .then(() => {
            this.$store.dispatch('promotions/getOrder', this.orderId);
            this.$router.push({ name: 'promotion-details', params: { id: this.orderId } });
            return query;
          })
          .catch((err) => err)
          .finally(() => {
            this.isUpdatingLineItem = false;
          });
      },
    },
  };
</script>
